import { makeStyles, Theme } from '@material-ui/core/styles';
import { BrandColors } from '../../constants';

export const DialogBoxStyles = makeStyles((theme: Theme) => ({
  box: {
    padding: '46px 24px 24px',
    [theme.breakpoints.up('sm')]: {
      padding: '22px 54px 25px',
    },
  },
  innerBox: {
    width: '100%',
  },
  button: {
    color: BrandColors.black,
    backgroundColor: BrandColors.white,
    '&:hover': {
      color: BrandColors.white,
      backgroundColor: BrandColors.black,
    },
  },
}));
